import {Plugin, PluginKey} from 'prosemirror-state';

export const PLUGIN_INTERFACE = new PluginKey('interface');

export const interfacePlugin = pm => {
  const plugin = new Plugin({ key: PLUGIN_INTERFACE });
  plugin.interface = pm;
  return plugin;
};
